import React, { FC, memo } from 'react';
import clsx from 'clsx';
import { FnButtonTypes, FnButtonVariants } from '../../../../elements/FnButton/constants';
import FnButton from '../../../../elements/FnButton';
import { DivFooter, DivGuidance } from './styles';

type TProps = {
  okText?: string;
  okViewType?: FnButtonTypes;
  okVariant?: FnButtonVariants;
  okDisabled?: boolean;
  onOk?: () => void;
  cancelText?: string;
  cancelViewType?: FnButtonTypes;
  cancelVariant?: FnButtonVariants;
  cancelDisabled?: boolean;
  onCancel?: () => void;
  footerCentered?: boolean;
  guidance?: string;
};

const FnFooterModal: FC<TProps> = ({
  okText = '',
  okViewType = FnButtonTypes.Default,
  okVariant = FnButtonVariants.Primary,
  okDisabled = false,
  onOk = null,
  cancelText = '',
  cancelViewType = FnButtonTypes.Text,
  cancelVariant = FnButtonVariants.Secondary,
  cancelDisabled = false,
  onCancel = null,
  footerCentered = false,
  guidance = ''
}) => {
  return (
    <>
      {guidance && <DivGuidance className={clsx({ ['footer-centered']: footerCentered })}>{guidance}</DivGuidance>}

      <DivFooter className={clsx({ ['footer-centered']: footerCentered })}>
        {okText && (
          <FnButton text={okText} viewType={okViewType} variant={okVariant} onClick={onOk} disabled={okDisabled}/>
        )}
        {cancelText && (
          <FnButton
            text={cancelText}
            viewType={cancelViewType}
            variant={cancelVariant}
            onClick={onCancel}
            disabled={cancelDisabled}
          />
        )}
      </DivFooter>
    </>
  );
};

export default memo(FnFooterModal);
